<template>
    <van-popup v-model:show="show" @click-overlay="close" position="bottom" :style="{
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }">
        <div class="popupContainer">
            <van-row class="headBar">
                <van-col span="5">
                    <div class="logo">
                        <img src="@/assets/themeThree/K6501.png" alt="">
                    </div>
                </van-col>
                <van-col span="15" style="padding: 10px;">
                    <div class="text1">{{ $t('pwa.text3') }}</div>
                    <div class="text2">{{ $t('pwa.text2') }}</div>
                </van-col>
                <van-col span="2" offset="2">
                    <div class="closeIcon">
                        <img src="@/assets/themetwo/Close_02-1.png" alt="" @click="close">
                    </div>
                </van-col>
            </van-row>

            <div style="padding: 0 20px;">
                <div class="title">{{ $t('pwa.title') }}</div>
                <div style="padding: 0 20px;">
                    <div class="detailsBg">
                        <div class="infoText">
                            {{ title }}
                        </div>
                    </div>

                </div>
            </div>

            <div style="padding: 15px;">
                <div class="title2">{{ $t('pwa.installIntroTitle') }}</div>
                <div class="installInfo" v-html="$t('pwa.installIntro1')"></div>


                <div class="introCard">
                    <div class="title3">{{ $t('pwa.installIntroTitle') }}</div>
                    <div class="installInfo2">{{ $t('pwa.installIntro2') }}</div>
                </div>
            </div>

        </div>

    </van-popup>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import { useI18n } from 'vue-i18n';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useUserStore } from '@/stores/user';
const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const title = ref('')
const contactRef = ref()

const open = (value: string) => {
    show.value = true
    title.value = value
    userStore.setPwaShowing(false)
}


const close = () => {
    show.value = false
    // contactRef.value.close()
    userStore.setPwaShowing(false)
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

const openContactPopup = () => {
    contactRef.value.open()
}

defineExpose({
    open,
    close
})
</script>
<style scoped>
.popupContainer {
    background: #080E1D;
    border-radius: 25px 25px 0 0;
    width: 100%;
    overflow: hidden;
}

.van-overlay {
    z-index: 9999 !important;
    backdrop-filter: blur(.26667rem);
}

.headBar {
    background-color: #080E1D;
    background-image: 
        linear-gradient(to bottom, #15428B 0%, #080E1D 100%),
        radial-gradient(at 0% 0%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
    
    padding: 24px 20px;
    display: flex;
    position: relative;
    overflow: hidden;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
.logo{
    height: 100%;
    display: flex;
    align-items: center;
}

.logo img {
    width: 60px; /* Specific size is usually safer than percentages */
    height: 60px;
    object-fit: contain;
    filter: drop-shadow(0 4px 10px rgba(0,0,0,0.3));
}

.text1 {
    font-weight: 700;
    color: #fff;
    padding-bottom: 4px;
    font-size: 17px;
    letter-spacing: 0.5px;
}

.text2 {
    color: rgba(255, 255, 255, 0.6);
    font-size: 13px;
    line-height: 1.4;
}

.closeIcon {
    display: flex;
    justify-content: right;
}

.closeIcon img {
    width: 25px;
    padding: 2px;
    background-color: #000;
    border-radius: 30px;
}

.bannerImg {
    padding: 5px;
}

.bannerImg img {
    width: 100%;
}

.title {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0 5px;
    color: #fff;
}

.title2 {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    padding-bottom: 10px;
}

.installInfo {
    color: #969799;
    font-size: 12px;
    padding: 5px 0;
}

.introCard {
    background: #101629;
    padding: 10px;
    border-radius: 5px;
}

.title3 {
    color: #fff;
    font-size: 15px;
    padding-bottom: 10px;
}

.installInfo2 {
    color: #969799;
    font-size: 12px;
}

.detailsBg {
    margin-bottom: 15px;
    padding: 15px 10px;
}

.infoText {
    display: flex;
    justify-content: center;
    color: #c92222;
    font-size: 16px;
    padding: 5px;
    font-weight: bold;
}

.bonusBar {
    background: #00000014;
    color: #000000a6;
    border-radius: 30px;
    padding: 15px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
}

.bonusBar span {
    color: #fff;
    font-size: 17px;
}

.bonusBar img {
    width: 25px;
    padding-right: 10px;
}

.linkBtn {
    background-image: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    /* border: 1.5px solid rgba(249, 196, 134, 1); */
    padding: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 30px;
    color: #FFFFFF;
    font-size: 15px;
    width: 90%;
}

.linkBtn img {
    width: 25px;
    padding-right: 10px;
}

.serviceIcon {
    display: flex;
    justify-content: center;
    align-items: center;
}

.serviceIcon img {
    width: 40%;
    padding: 12px;
    border-radius: 30px;
    background: #00000040;
}

.alignment {
    display: flex;
    justify-content: center;
    align-items: center;
}

@media (max-width: 360px) {
  .popupContainer {
    border-radius: 18px 18px 0 0;
  }

  .headBar {
    padding: 16px 12px;
  }

  .logo img {
    width: 45px;
    height: 45px;
  }

  .text1 {
    font-size: 14px;
  }

  .text2 {
    font-size: 11px;
  }

  .closeIcon img {
    width: 20px;
  }

  .title {
    font-size: 16px;
    padding: 10px 0 5px;
  }

  .title2,
  .title3 {
    font-size: 13px;
  }

  .installInfo,
  .installInfo2 {
    font-size: 11px;
  }

  .infoText {
    font-size: 14px;
  }

  .detailsBg {
    padding: 10px 8px;
  }

  .introCard {
    padding: 8px;
  }
}
</style>